import { OmitDeep } from "type-fest";
import { ChartAxisRangeOptions } from "../../config/type/chart-axes-options";
import { ChartLegendPosition } from "../../config/type/chart-legend-options";
import { ChartOptions } from "../../config/type/chart-options";
import { createPluginOptions } from "../create-plugin-options";

const range: ChartAxisRangeOptions = {
	max: null,
	min: null,
};

export const defaultTimeHistoryOptions = createPluginOptions<ChartOptions>()({
	axes: {
		bottom: {
			grid: false,
		},
		left: {
			visible: true,
			grid: true,
			label: "",
			range,
			logScale: false,
		},
		right: {
			visible: false,
			grid: false,
			label: "",
			range,
			logScale: false,
		},
	},
	legend: {
		visible: true,
		position: "bottom" as ChartLegendPosition,
		showValue: true,
	},
});

export type TimeHistoryOptionsV1 = OmitDeep<
	TimeHistoryOptions,
	"axes.left.logScale" | "axes.right.logScale"
>;
export type TimeHistoryOptionsV2 = TimeHistoryOptions;

export type TimeHistoryOptions = typeof defaultTimeHistoryOptions;
